import {Column, Entity, ManyToOne} from "typeorm";
import type {Relation} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Min} from "class-validator";
import {TerraceTypeEnum} from "@/modules/stadium/enums";
import {StadiumLog} from "@/modules/stadium/entity";

@Entity()
export class TerraceLog extends BaseEntity {
  @ManyToOne(() => StadiumLog, r => r.terraceLogs)
  stadiumLog: Relation<StadiumLog>;

  @Column({type: 'varchar', enum: TerraceTypeEnum})
  type: TerraceTypeEnum;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  seats: number;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  capacity: number;
}
